import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import API_URL from "../../config";
import { useNavigate } from "react-router-dom";

const AIUsage = () => {
  const [usageData, setUsageData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAIUsage();
  }, []);

  const fetchAIUsage = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${API_URL}/api/admin/ai-usage`);

      setUsageData(res.data.data || []);
    } catch (error) {
      console.error("Error fetching AI usage:", error);
      setUsageData([]);
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-IN").format(number || 0);
  };

  const filteredUsage = useMemo(() => {
    return usageData.filter((user) => {
      const search = searchTerm.toLowerCase();

      return (
        user.name?.toLowerCase().includes(search) ||
        user.email?.toLowerCase().includes(search)
      );
    });
  }, [usageData, searchTerm]);

  const totals = useMemo(() => {
    return usageData.reduce(
      (acc, user) => {
        acc.promptTokens += user.promptTokens || 0;
        acc.completionTokens += user.completionTokens || 0;
        acc.totalTokens += user.totalTokens || 0;
        // acc.requests += user.requests || 0;

        return acc;
      },
      {
        promptTokens: 0,
        completionTokens: 0,
        totalTokens: 0,
        // requests: 0,
      },
    );
  }, [usageData]);

  return (
    <div className="body-wrapper py-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold mb-1" style={{ color: "#6600cc" }}>
            AI Token Usage
          </h4>

          <small className="text-main">Monitor AI usage across all users</small>
        </div>

        <button
          className="btn btn-primary"
          onClick={fetchAIUsage}
          disabled={loading}
        >
          {loading ? "Refreshing..." : "Refresh"}
        </button>
      </div>

      <div className="row mb-4">
        {/* <div className="col-xl-3 col-md-6 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <small className="text-heading">Total Requests</small>

              <h4 className="fw-bold mt-2 mb-0 text-main">
                {formatNumber(totals.requests)}
              </h4>
            </div>
          </div>
        </div> */}

        <div className="col-xl-4 col-md-6 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <small className="text-heading">Prompt Tokens</small>

              <h4 className="fw-bold mt-2 mb-0 text-main">
                {formatNumber(totals.promptTokens)}
              </h4>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-md-6 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <small className="text-heading">Completion Tokens</small>

              <h4 className="fw-bold mt-2 mb-0 text-main">
                {formatNumber(totals.completionTokens)}
              </h4>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-md-6 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <small className="text-heading">Total Tokens</small>

              <h4 className="fw-bold mt-2 mb-0" style={{ color: "#6600cc" }}>
                {formatNumber(totals.totalTokens)}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="fw-semibold mb-0 text-heading">User Usage</h5>

            <input
              type="text"
              className="form-control"
              style={{ maxWidth: "300px" }}
              placeholder="Search user..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div
                className="spinner-border"
                role="status"
                style={{ color: "#6600cc" }}
              />
              <div className="mt-2 text-main">Loading AI usage...</div>
            </div>
          ) : filteredUsage.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-main mb-0">No AI usage data found.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table align-middle">
                <thead>
                  <tr>
                    <th>User</th>
                    {/* <th>Requests</th> */}
                    <th>Prompt Tokens</th>
                    <th>Completion Tokens</th>
                    <th>Total Tokens</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredUsage.map((user) => (
                    <tr
                      key={user.userId}
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/admin/token-usage/${user.userId}`)
                      }
                    >
                      <td>
                        <div className="fw-semibold text-black text-capitalize">
                          {`${user.firstName} ${user.lastName}` ||
                            "Unknown User"}
                        </div>

                        <small className="text-main">{user.email}</small>
                      </td>

                        {/* <td>
                          <span className="badge bg-light text-main">
                            {formatNumber(user.requests)}
                          </span>
                        </td> */}

                      <td>{formatNumber(user.promptTokens)}</td>

                      <td>{formatNumber(user.completionTokens)}</td>

                      <td>
                        <strong style={{ color: "#6600cc" }}>
                          {formatNumber(user.totalTokens)}
                        </strong>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <style>{`
        .text-main {
            color : #6600cc
        }
        .text-heading {
            color : #000
        }
      `}</style>
    </div>
  );
};

export default AIUsage;
